import { render, staticRenderFns } from "./all-global-controls.vue?vue&type=template&id=87804220&scoped=true&"
import script from "./all-global-controls.vue?vue&type=script&lang=js&"
export * from "./all-global-controls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87804220",
  null
  
)

export default component.exports